<template>
    <div class="spinner__box">
        <svg
            :style="additionStyle"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            style="margin: auto; background: none; display: block; shape-rendering: auto; animation-play-state: running; animation-delay: 0s;"
            width="80px"
            height="80px"
            viewBox="0 0 100 100"
            preserveAspectRatio="xMidYMid"
        >
            <circle
                cx="50"
                cy="50"
                fill="none"
                stroke-width="10"
                r="35"
                stroke-dasharray="164.93361431346415 56.97787143782138"
                style="animation-play-state: running; animation-delay: 0s;"
                :stroke="mainStrokeColor"
            >
                <animateTransform
                    attributeName="transform"
                    type="rotate"
                    repeatCount="indefinite"
                    dur="1s"
                    values="0 50 50;360 50 50"
                    keyTimes="0;1"
                    style="animation-play-state: running; animation-delay: 0s;"
                ></animateTransform>
            </circle>
            <!-- [ldio] generated by https://loading.io/ -->
        </svg>
    </div>
</template>

<script>
export default {
    props: {
        additionStyle: {
            required: false,
            type: String
        },

        strokeColor: {
            required: false,
            type: String
        }
    },

    data() {
        return {
            mainStrokeColor: "#6C9672"
        };
    },

    methods: {
        updateMainStrokeColor() {
            if (!!this.strokeColor) this.mainStrokeColor = this.strokeColor;
        }
    },

    mounted() {
        this.updateMainStrokeColor();
    }
};
</script>

<style lang="scss" scoped>
.spinner__box {
    display: flex;
    justify-content: center;
    align-items: center;

    svg {
        max-height: 100%;
        max-width: 100%;
    }
}
</style>
